(() => {
  function initialize(scope) {
    scope.querySelectorAll('[data-customization]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      function update() {
        const idea = root.querySelector('[data-path="idea"]')?.checked;
        const product = root.querySelector('[data-product]');
        if (!product) return;
        root.querySelector('[data-form-title]').textContent = idea ? 'Help shape our next launch' : 'Your product, your preferences';
        root.querySelector('[data-product-label]').textContent = idea ? 'Your product idea' : 'Product name or product link';
        product.placeholder = idea ? 'What would you love us to make?' : 'Which product would you like to personalize?';
        root.querySelector('[data-options-label]').textContent = idea ? 'What matters most in this product? (optional)' : 'What would you like to change? (optional)';
        root.querySelector('[data-submit-label]').textContent = idea ? 'Share my idea' : 'Share my request';
      }
      root.querySelectorAll('[data-path]').forEach(input => input.addEventListener('change', update));
      update();
      root.querySelector('[data-result]')?.focus();
      // Native submission lets Shopify handle validation, spam protection and delivery.
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
